import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getDashboardStats, getClasses, getFollowUps, DashboardStats, ClassOut, FollowUp } from "../api/client";

export default function Dashboard() {
  const [stats, setStats] = useState<DashboardStats | null>(null);
  const [classes, setClasses] = useState<ClassOut[]>([]);
  const [followUps, setFollowUps] = useState<FollowUp[]>([]);

  useEffect(() => {
    getDashboardStats().then((r) => setStats(r.data));
    getClasses().then((r) => setClasses(r.data));
    getFollowUps(undefined, "pending").then((r) => setFollowUps(r.data));
  }, []);

  return (
    <div>
      <h2>Dashboard</h2>

      <div className="stats-grid">
        <div className="stat-card">
          <div className="label">Active Classes</div>
          <div className="value">{stats?.total_classes ?? "-"}</div>
        </div>
        <div className="stat-card">
          <div className="label">Active Students</div>
          <div className="value">{stats?.total_students ?? "-"}</div>
        </div>
        <div className="stat-card">
          <div className="label">Assignments</div>
          <div className="value">{stats?.total_assignments ?? "-"}</div>
        </div>
        <div className="stat-card">
          <div className="label">Attendance (30d)</div>
          <div className="value">{stats?.attendance_rate_30d ?? "-"}%</div>
        </div>
        <div className="stat-card">
          <div className="label">Pending Follow-ups</div>
          <div className="value">{stats?.pending_follow_ups ?? "-"}</div>
        </div>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 24 }}>
        <div>
          <h3 style={{ marginBottom: 12 }}>Classes</h3>
          <div className="table-container">
            {classes.length === 0 ? (
              <div className="empty">No classes yet. <Link to="/classes" style={{ color: "var(--accent)" }}>Create one</Link></div>
            ) : (
              <table>
                <thead>
                  <tr><th>Name</th><th>Schedule</th><th>Students</th></tr>
                </thead>
                <tbody>
                  {classes.map((c) => (
                    <tr key={c.id}>
                      <td><Link to={`/classes/${c.id}`} style={{ color: "var(--accent)", fontWeight: 500 }}>{c.name}</Link></td>
                      <td>{c.schedule || "-"}</td>
                      <td>{c.student_count}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>

        <div>
          <h3 style={{ marginBottom: 12 }}>Pending Follow-ups</h3>
          <div className="table-container">
            {followUps.length === 0 ? (
              <div className="empty">All clear</div>
            ) : (
              <table>
                <thead>
                  <tr><th>Type</th><th>Reason</th></tr>
                </thead>
                <tbody>
                  {followUps.slice(0, 5).map((f) => (
                    <tr key={f.id}>
                      <td><span className={`badge ${f.type}`}>{f.type}</span></td>
                      <td>{f.reason}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
